module.exports = __webpack_public_path__ + "static/hero-dd0af12e905fe1067570c73eb1d10814.mp4";